// extracted by mini-css-extract-plugin
export default {"addFilterBtn":"style_addFilterBtn__E73Hm","addFilterIcon":"style_addFilterIcon__4VLqS","goToEnrichment":"style_goToEnrichment__7tX0W"};